export default "__VITE_ASSET__6ab6a1a2__"